import React from 'react'
import { useTranslation } from 'react-i18next'
import { usePage } from '@inertiajs/react'
import FormQuestion from '@/pages/Afnor/components/FormQuestion'
import type { FormInstance } from 'antd/es/form/hooks/useForm'
import type { CheckboxOptionType } from 'antd'
import FormUnderQuestion from '@/pages/Afnor/components/FormUnderQuestion'

export type afnorStepGlobalFormItemProps = {
    globalForm: FormInstance
}

const ResponsibleShoppingFoodWasteLevelOfCommitment2 = ({ globalForm }: afnorStepGlobalFormItemProps) => {
    const { t } = useTranslation('afnor')
    const { imperativeAnswer } = usePage().props

    return (
        <>
            <FormQuestion
                questionKey={'Q3_2_1'}
                question={t('afnor:responsibleShoppingFoodWaste.levelOfCommitment2.questions.Q3_2_1')}
                checkboxOption={imperativeAnswer as CheckboxOptionType[]}
                form={globalForm}
            />

            <FormQuestion
                questionKey={'Q3_2_2'}
                question={t('afnor:responsibleShoppingFoodWaste.levelOfCommitment2.questions.Q3_2_2')}
                checkboxOption={imperativeAnswer as CheckboxOptionType[]}
                form={globalForm}
                withAnswer={false}
                subQuestionLabel={t('afnor:responsibleShoppingFoodWaste.levelOfCommitment2.questions.Q3_2_2_sub')}
                withProof={false}
            />

            <FormUnderQuestion
                questionKey={'Q3_2_2_A'}
                question={t('afnor:responsibleShoppingFoodWaste.levelOfCommitment2.questions.Q3_2_2_A')}
                checkboxOption={imperativeAnswer as CheckboxOptionType[]}
                form={globalForm}
                withHint={false}
            />

            <FormUnderQuestion
                questionKey={'Q3_2_2_B'}
                question={t('afnor:responsibleShoppingFoodWaste.levelOfCommitment2.questions.Q3_2_2_B')}
                checkboxOption={imperativeAnswer as CheckboxOptionType[]}
                form={globalForm}
                withHint={false}
            />

            <FormQuestion
                questionKey={'Q3_2_3'}
                question={t('afnor:responsibleShoppingFoodWaste.levelOfCommitment2.questions.Q3_2_3')}
                checkboxOption={imperativeAnswer as CheckboxOptionType[]}
                form={globalForm}
                withAnswer={false}
                subQuestionLabel={t('afnor:responsibleShoppingFoodWaste.levelOfCommitment2.questions.Q3_2_3_sub')}
                withProof={false}
            />

            <FormUnderQuestion
                questionKey={'Q3_2_3_A'}
                question={t('afnor:responsibleShoppingFoodWaste.levelOfCommitment2.questions.Q3_2_3_A')}
                checkboxOption={imperativeAnswer as CheckboxOptionType[]}
                form={globalForm}
                withHint={false}
            />

            <FormUnderQuestion
                questionKey={'Q3_2_3_B'}
                question={t('afnor:responsibleShoppingFoodWaste.levelOfCommitment2.questions.Q3_2_3_B')}
                checkboxOption={imperativeAnswer as CheckboxOptionType[]}
                form={globalForm}
                withHint={false}
            />

            <FormUnderQuestion
                questionKey={'Q3_2_3_C'}
                question={t('afnor:responsibleShoppingFoodWaste.levelOfCommitment2.questions.Q3_2_3_C')}
                checkboxOption={imperativeAnswer as CheckboxOptionType[]}
                form={globalForm}
                withHint={false}
            />

            <FormUnderQuestion
                questionKey={'Q3_2_3_D'}
                question={t('afnor:responsibleShoppingFoodWaste.levelOfCommitment2.questions.Q3_2_3_D')}
                checkboxOption={imperativeAnswer as CheckboxOptionType[]}
                form={globalForm}
                withHint={false}
            />

            <FormUnderQuestion
                questionKey={'Q3_2_3_E'}
                question={t('afnor:responsibleShoppingFoodWaste.levelOfCommitment2.questions.Q3_2_3_E')}
                checkboxOption={imperativeAnswer as CheckboxOptionType[]}
                form={globalForm}
                withHint={false}
            />
        </>
    )
}

export default ResponsibleShoppingFoodWasteLevelOfCommitment2
